import { Dispatch } from "../../common/Dispatch";
import { DispatchSearchParams } from "../../common/Dispatch";
import { baseApi } from "./base";

export const dispatchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDispatches: builder.query<Dispatch[], Partial<DispatchSearchParams>>({
      query: ({ vesselId, fleetId, marinerIds, ratings, current }) => {
        let url = `dispatches/${!!vesselId ? "&vesselId=" + vesselId : ""}${
          !!fleetId ? "&fleetId=" + fleetId : ""
        }${!!marinerIds ? "&marinerIds=" + marinerIds.join(",") : ""}${
          !!ratings ? "&ratings=" + ratings.join(",") : ""
        }${"&current=" + current}
        `;
        url = url.replace("dispatches/&", "dispatches?");
        return {
          method: "GET",
          url,
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Dispatch" as const, id })),
              { type: "Dispatch", id: "LIST" },
            ]
          : [{ type: "Dispatch", id: "LIST" }],
    }),
    getDispatch: builder.query<Dispatch, String>({
      query: (dispatchId) => {
        return {
          method: "GET",
          url: `dispatches/${dispatchId}`,
        };
      },
    }),
    createDispatch: builder.mutation<Dispatch, Partial<Dispatch>>({
      query: (dispatch) => {
        return {
          method: "POST",
          url: "dispatches/",
          body: dispatch,
        };
      },
      invalidatesTags: [{ type: "Dispatch", id: "LIST" }],
    }),
    createDispatchFromJobOrder: builder.mutation<Dispatch, String>({
      query: (jobOrderId) => {
        return {
          method: "POST",
          url: `dispatches/${jobOrderId}`,
        };
      },
      invalidatesTags: [{ type: "Dispatch", id: "LIST" }],
    }),
    saveDispatches: builder.mutation<
      { successCount: number; failedCount: number },
      { dispatches: Partial<Dispatch>[] }
    >({
      async queryFn({ dispatches }, _queryApi, _extraOptions, baseQuery) {
        let successCount: number = 0;
        let failedCount: number = 0;
        for (const dispatch of dispatches) {
          const response = await baseQuery({
            method: "PATCH",
            url: `dispatches/${dispatch.id}/`,
            body: dispatch,
          });
          if ("error" in response) {
            failedCount += 1;
          } else {
            successCount += 1;
          }
        }
        return { data: { successCount, failedCount } };
      },
      invalidatesTags: ["Dispatch", { type: "Dispatch", id: "LIST" }],
    }),
    getEvaluateeDispatches: builder.query<Dispatch[], {}>({
          query: () => {
            return {
              method: "GET",
              url: "dispatches/eval",
            };
          },
          providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Dispatch" as const, id })),
              { type: "Dispatch", id: "LIST" },
            ]
          : [{ type: "Dispatch", id: "LIST" }],
        }),
  }),
  overrideExisting: false,
});

export const {
  useGetDispatchesQuery,
  useGetDispatchQuery,
  useCreateDispatchMutation,
  useCreateDispatchFromJobOrderMutation,
  useSaveDispatchesMutation,
  useGetEvaluateeDispatchesQuery,
} = dispatchApi;
